/* eslint-disable max-len */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { Card, Flex, Table, Typography } from 'antd';

const { Text, Paragraph, Title } = Typography;

class Partners extends Component<IRootStoreProps> {
  componentDidMount(): void {
    const { isVerivield, getReferrals } = this.props.store.user;

    if (isVerivield) {
      getReferrals();
    }
  }

  render(): React.ReactNode {
    const { user } = this.props.store;

    const columns = [
      {
        title: 'Логин',
        dataIndex: 'login',
        key: 'login',
        render: (id: string) => (
          <Text ellipsis={{ tooltip: id }} style={{ maxWidth: 150 }}>
            {id}
          </Text>
        ),
      },
      { title: 'Реф.Доход', dataIndex: 'profit', key: 'profit', sorter: true },
      { title: 'Сыграно игр', dataIndex: 'games', key: 'games', sorter: true },
      { title: 'Выиграно игр', dataIndex: 'winner', key: 'winner', sorter: true },
    ];

    return (
      <Card bordered={false} title="Партнерская программа" style={{ marginBottom: 8 }}>
        <Paragraph>
          {
            'Привлекая новых игроков в наш проект, вы будете получать до 50% от прибыли нашего клуба с каждой ставки привлеченного вами игрока в зависимости от партнёрского уровня в системе.'
          }
        </Paragraph>
        <Paragraph>
          {'Зачисление денег происходит моментально на ваш счет после игры привлеченного вами игрока.'}
        </Paragraph>
        <Paragraph>
          {
            'После регистрации вам будет предоставлена партнёрская в разделе "Мои рефералы"-"Промо материалы", по которой вы сможете приглашать игроков.'
          }
        </Paragraph>
        <Paragraph>{'Так же там есть стандартные промо материалы.'}</Paragraph>
        <Paragraph>{'Вы можете использовать любые виды рекламы, кроме спама.'}</Paragraph>

        {user.isVerivield && (
          <>
            <Flex vertical>
              <Title level={5}>{'Ваша партнерская ссылка'}</Title>
              <Text>{`${process.env.REACT_APP_FRONT_URL}auth/registration?ref=${user.data?.login}`}</Text>
            </Flex>

            <Title level={5}>{'Ваши рефералы'}</Title>
            <Table
              dataSource={user.referralList}
              columns={columns}
              pagination={{ total: user.referralsTotal, pageSize: user.getTransfersParams.limit }}
              onChange={user.handleRefTableChange}
            />
          </>
        )}
      </Card>
    );
  }
}

export const PartnersPage: WithoutStore = withStore(observer(Partners));
